// @ts-ignore
import { createClient } from "@supabase/supabase-js";

// Hard-coded keys to bypass CodeSandbox environment errors
const supabaseUrl = "https://dpsrbqvcukoomuupjfdm.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRwc3JicXZjdWtvb211dXBqZmRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzNjYzOTMsImV4cCI6MjA4OTk0MjM5M30.jHEtPz5--N5gbiktgP3vQBQmPRQvU1vtH8xUeEq5Swk";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
